<template>
  <sc-table
    :loading="loadingUploadList"
    :data="cteUploadList"
    :total="cteUploadListTotal"
    :per-page="pagination.size"
    :current-page="pagination.page"
    :paginated="true"
    :backend-pagination="true"
    @page-change="(newPage) => pagination.page = newPage">
    <template slot-scope="{ row }">
      <sc-table-column label="Nome do arquivo" field="filename">
        {{ row.filename }}
      </sc-table-column>

      <sc-table-column label="Quantidade de CT-e" field="files_total">
        {{ row.files_total }}
      </sc-table-column>

      <sc-table-column label="Solicitação de upload" field="upload_request_date">
        {{ row.upload_request_date | date("DD/MM/YYYY") }} às
        {{ row.upload_request_date | date("HH:mm") }}
      </sc-table-column>

      <sc-table-column label="Início de upload" field="upload_start_date">
        <span v-if="row.upload_start_date">
          {{ row.upload_start_date | date("DD/MM/YYYY") }} às
          {{ row.upload_start_date | date("HH:mm") }}
        </span>
      </sc-table-column>

      <sc-table-column label="Status" field="upload_status">
        <span :class="[`status-col-${row.upload_status.toLowerCase()}`]">
          <sc-icon :icon="statusTranslations[row.upload_status].icon" size="is-small" />
          {{ statusTranslations[row.upload_status].text }}
        </span>
      </sc-table-column>
    </template>

    <template slot="footer">
      <p v-if="cteUploadListTotal">
        <strong>Total de registros:</strong>
        <span>{{ cteUploadListTotal }}</span>
      </p>
    </template>

    <template slot="bottom-left">
      <sc-table-per-page v-model="pagination.size" />
    </template>

    <template slot="empty">
      <sc-table-empty />
    </template>
  </sc-table>
</template>
<script>
import {
  ScIcon,
  ScTable,
  ScTableColumn,
  ScTableEmpty,
  ScTablePerPage,
} from '@intelipost-js/secure-components';

import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('recon/cteUpload');

export default {
  name: 'sc-cte-upload-list',
  data() {
    return {
      pagination: {
        page: 1,
        size: 10,
      },
      statusTranslations: {
        WAITING: { text: 'Upload em processo. Aguarde...', icon: 'fas fa-spinner fa-spin' },
        PROCESSING: { text: 'Upload em processo. Aguarde...', icon: 'fas fa-spinner fa-spin' },
        SUCCESS: { text: 'Upload concluído', icon: 'fas fa-check' },
        ERROR: { text: 'Upload com erro. Tente novamente', icon: 'fas fa-exclamation-triangle' },
      },
    };
  },
  methods: {
    ...mapActions(['getUploadList']),
  },
  computed: {
    ...mapState(['cteUploadList', 'cteUploadListTotal', 'loadingUploadList', 'loadingUploadForm']),
    currentPage() {
      return this.pagination.page;
    },
    currentSize() {
      return this.pagination.size;
    },
  },
  watch: {
    currentPage() {
      this.getUploadList({ ...this.pagination });
    },
    currentSize() {
      this.getUploadList({ ...this.pagination });
    },
    loadingUploadForm(value) {
      if (!value) { // refresh list after upload is completed
        this.getUploadList({ ...this.pagination });
      }
    },
  },
  beforeMount() {
    this.getUploadList({ ...this.pagination });
  },
  components: {
    ScIcon,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScTablePerPage,
  },
};
</script>
<style lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line
.status-col-success {
  color: #09A83D;
}
.status-col-error {
  color: $danger;
}
.status-col-waiting, .status-col-processing {
  color: $grey;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/cte-upload/components/sc-cte-upload-list/ScCteUploadList.vue